var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0511 11.7325L12.9579 14.8992C12.7811 15.0751 12.5464 15.1719 12.2969 15.1719C12.0465 15.1719 11.8111 15.0743 11.6327 14.896L8.44285 11.7264C8.2599 11.5442 8.0206 11.4531 7.78126 11.4531C7.54074 11.4531 7.30018 11.5451 7.11704 11.729C6.75165 12.0959 6.75277 12.6895 7.11966 13.0548L10.3082 16.2231C10.8393 16.7543 11.5457 17.0469 12.2969 17.0469C13.0481 17.0469 13.7544 16.7543 14.2856 16.2231C14.2872 16.2215 14.2887 16.2199 14.2903 16.2183L17.3864 13.0488C17.7499 12.6801 17.7456 12.0865 17.3769 11.723C17.0082 11.3595 16.4145 11.3637 16.0511 11.7325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1875 11.4219L13.1875 2.9375C13.1875 2.41972 12.7678 2 12.25 2C11.7322 2 11.3125 2.41972 11.3125 2.9375L11.3125 11.4219C11.3125 11.9397 11.7322 12.3594 12.25 12.3594C12.7678 12.3594 13.1875 11.9397 13.1875 11.4219Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3125 16.3125C20.7947 16.3125 20.375 16.7322 20.375 17.25C20.375 18.2839 19.5339 19.125 18.5 19.125H6C4.96613 19.125 4.125 18.2839 4.125 17.25C4.125 16.7322 3.70528 16.3125 3.1875 16.3125C2.66972 16.3125 2.25 16.7322 2.25 17.25C2.25 19.3177 3.93225 21 6 21H18.5C20.5677 21 22.25 19.3177 22.25 17.25C22.25 16.7322 21.8303 16.3125 21.3125 16.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7c7e484292c918839e141ea276824344.svg";
export { ForwardRef as ReactComponent };